/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Bonisoft Backend API
 * Bonisoft Backend API
 * OpenAPI spec version: 1.0
 */

export type ServiceModuleType = typeof ServiceModuleType[keyof typeof ServiceModuleType];


export const ServiceModuleType = {
  Undefined: 'Undefined',
  Calendar: 'Calendar',
  File: 'File',
  Folder: 'Folder',
  Text: 'Text',
  Url: 'Url',
  Leaderboard: 'Leaderboard',
  Timetracking: 'Timetracking',
  Absence: 'Absence',
  PersonalDocuments: 'PersonalDocuments',
  StatusSystem: 'StatusSystem',
  Insurance: 'Insurance',
} as const;
